import { Stack } from '@mui/material';
import Link from 'next/link';
import PropTypes from 'prop-types';

import blogConfig from '@/configs/blog';
import { blogCategoryPropType } from '@/constants/propTypes';
import useFormatMessage from '@/hooks/useFormatMessage';

import { Chip } from './Filters.style';

const Filters = ({ activeCategory, categories }) => {
  const formatMessage = useFormatMessage();
  const allCategories = [
    {
      title: formatMessage(`blog_category_All`),
      pathname: blogConfig.allCategoryPathname,
    },
    ...categories.map(({ attributes }) => ({
      title: attributes.title,
      pathname: attributes.metadata.pathname,
    })),
  ];

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      mb={{ xs: 6 }}
      sx={{ position: 'relative', zIndex: 1 }}>
      {allCategories.map(({ title, pathname }) => {
        const active = `/${activeCategory}` == pathname;
        return (
          <Chip
            key={title}
            label={title}
            variant="filled"
            color={active ? 'primary' : 'default'}
            sx={{ mr: 1.5, mb: 1.5 }}
            component={Link}
            href={`${blogConfig.basePathname}${pathname}`}
            scroll={false}
          />
        );
      })}
    </Stack>
  );
};

Filters.propTypes = {
  activeCategory: PropTypes.string,
  categories: PropTypes.arrayOf(blogCategoryPropType),
};

Filters.defaultProps = {
  activeCategory: '',
};

export default Filters;
